export default class MobileMenu {
    constructor($el) {
        this.$menu = $el;
        this.$trigger =  document.querySelector('[data-mobile-menu-trigger]');
        this.$childMenuTriggers = this.$menu.querySelectorAll('[data-open-child-menu] [data-menu-link]');

        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleChildMenu = this.toggleChildMenu.bind(this);
        this.openChildMenu = this.openChildMenu.bind(this);
        this.closeChildMenu = this.closeChildMenu.bind(this);

        this.$trigger.addEventListener('click', this.toggleMenu);
        this.$childMenuTriggers.forEach($trigger => $trigger.addEventListener('click', this.toggleChildMenu));
    }

    /**
     * Toggle menu
     * @param e
     */
    toggleMenu(e) {
        e.preventDefault();
        this.$trigger.classList.toggle('elementor-active');
    }

    toggleChildMenu(e) {
        e.preventDefault();
        const $item = e.target.closest('[data-open-child-menu]')
        const $link = $item.querySelector('[data-menu-link]');

        if ($link.classList.contains('highlighted')) {
            this.closeChildMenu(e);
        } else {
            this.openChildMenu(e);
        }
    }

    /**
     * Open child menu
     * @param e
     */
    openChildMenu(e) {
        const $item = e.target.closest('[data-open-child-menu]')
        const $link = $item.querySelector('[data-menu-link]');
        const $menu = $item.querySelector('[data-child-menu]');
        $link.classList.add('highlighted');
        $link.setAttribute('aria-expanded', true);
        $menu.style.display = 'block';
        $menu.setAttribute('aria-hidden', false);
    }

    /**
     * Close child menu
     * @param e
     */
    closeChildMenu(e) {
        const $item = e.target.closest('[data-open-child-menu]');
        const $link = $item.querySelector('[data-menu-link]');
        const $menu = $item.querySelector('[data-child-menu]');
        $link.classList.remove('highlighted');
        $link.setAttribute('aria-expanded', false);
        $menu.setAttribute('aria-hidden', true);
        $menu.style.display = 'none';
    }
}